import axios from 'axios';
import { NUMERODOCUMENTOUSUARIO } from 'config/general/Configuracion';
import { API_PLACAS, HEADERS, ID_CUENTA } from 'config/general/Configuracion';

class ApiClient {
  constructor() {
    this.url = API_PLACAS;
  }

  listarPlacas = (paginacion) => {
    const query = `limite=${paginacion.limite}&actual=${
      paginacion.actual
    }&filtro=${paginacion.filtro || ''}&orden=${paginacion.orden ||
      'placa'}&sentido=${paginacion.sentido || 'ASC'}`;
    return axios.get(
      `${this.url}/v1/placas/ciudad/me/${localStorage[ID_CUENTA]}/${localStorage[NUMERODOCUMENTOUSUARIO]}`,
      {
        headers: HEADERS(),
      }
    );
  };

  guardarPlaca = (placa) => {
    let respuesta = {
      method: "post",
      url: `${this.url}/v1/placas/guardar/${encodeURIComponent(
        localStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
      data: placa,
    };
    return respuesta;
  };


  actualizarPlaca = (placa) => {
    return axios.put(`${this.url}/v1/placas/actualizar/${placa.id}`, placa, {
      headers: HEADERS(),
      data: placa,
    });
  };
}

const PlacaApi = new ApiClient();
export default PlacaApi;
